import { takeLatest, delay } from 'redux-saga/effects';
import { call } from 'redux-saga/effects';
import AT from '../constants/action-types';
import { sendKioskCommand } from '../api';

import { reloadProviderData } from './helpers/reload-provider-data';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* processKioskCommandSaga(action: any) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { type, id, ...command } = action;
  yield call(sendKioskCommand, id, command);
  yield delay(4000);
  yield reloadProviderData();
}

export default function* controlBoxCommandSaga() {
  yield takeLatest(AT.KIOSK_COMMAND_SAGA, processKioskCommandSaga);
}
